import { useHttpClient } from "@/common/api/httpClient";
import { storeToRefs } from "pinia";
import { useMapStyleStore } from "shared/mapStyles/stores/mapStyleStore";
import { useLanguageStore } from "shared/translations/stores/languageStore";

export interface DeleteMapStyleRequest {
  styleId: string;
}

export interface DeleteMapStyleResponse {
  ok: true;
}

export function useDeleteMapStyle() {
  const httpClient = useHttpClient();
  const store = useMapStyleStore();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: DeleteMapStyleRequest) {

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`mapStyle/${action.styleId}`), {
      method: 'DELETE',
      headers,
    });

    const text = translations.value.mapStyles.actions.delete;

    const response = await httpClient.action<DeleteMapStyleResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      processOk() {
        return Promise.resolve({
          ok: true
        });
      },
    });

    if (response.ok) {
      store.deleteStyle(action.styleId);
    }

    return response;
  }
}
